import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 lg:px-10 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20breathtaking%20view%20of%20the%20Kunlun%20mountain%20range%20with%20pristine%20snow%20covered%20peaks%20glowing%20under%20soft%20golden%20hour%20sunlight%2C%20deep%20valleys%20with%20turquoise%20glacial%20streams%2C%20ethereal%20atmosphere%2C%20cinematic%20wide%20angle%20landscape%20photography&width=1800&height=600&seq=cta-kunlun-2026&orientation=landscape"
        alt="昆仑山壮丽全景"
        title="昆仑雪 - 源自世界屋脊的纯净力量"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-5 leading-tight">
          感受来自世界屋脊的<br />纯净力量
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-8 leading-relaxed max-w-xl mx-auto">
          昆仑雪，每一滴都承载着万年雪山的纯净力量。立即探索昆仑雪产品系列，开启您的极致纯净生活体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/categories"
            className="px-8 py-3.5 bg-accent-500 text-background-50 rounded-full font-medium text-sm hover:bg-accent-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            探索产品系列
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/25 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}